import { AsyncState, InstitutionAdminSettingsState } from './types';

export const INITIAL_STATE: InstitutionAdminSettingsState = {
  paginatedInstitutionEnrolments: {
    asyncState: AsyncState.INITIAL,
    enrolments: [],
    hasNextPage: false,
    hasPrevPage: false,
    total: 0,
    totalPages: 0,
  },
  paginatedPendingInvitations: {
    asyncState: AsyncState.INITIAL,
    hasNextPage: false,
    invitedUsers: [],
    total: 0,
  },
  coursesFilterData: {
    asyncState: AsyncState.INITIAL,
    allCourses: {},
  },
};
